import styles from "./styles.module.css";
import Table from "../../../components/TableConstructor";
import { MetaCalendario } from "../../../model/PlanoDeTrabalho/PlanoAplicacao";

import RowCalendario from "../../../components/TableConstructor/Row/RowCalendario";
import { MetaFisica } from "../../../model/PlanoDeTrabalho/CronogramaExecucao";

type Props = {
  passarPagina: Function;
  voltarPagina: Function;
  listaAplicacoesOSC: MetaCalendario[];
  listaAplicacoesOrgao: MetaCalendario[];
  title: React.JSX.Element;
};

function ReceitasDespesas({
  passarPagina,
  voltarPagina,
  listaAplicacoesOrgao,
  listaAplicacoesOSC,
  title,
}: Props) {
  return (
    <div>
      <h2 className={styles.titulo}>{title}</h2>
      <hr className={styles.separador} />
      <h3 className={styles.subTitulo}>Orgão/Entidade:</h3>
      <Table
        listTitle={[
          "Etapa/Fase",
          "Ano",
          "Jan",
          "Fev",
          "Mar",
          "Abr",
          "Mai",
          "Jun",
          "Jul",
          "Ago",
          "Set",
          "Out",
          "Nov",
          "Dez",
          "Total",
          "",
        ]}
        styleList={[1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]}
      >
        {listaAplicacoesOrgao.map((metaObj, index) => (
          <RowCalendario metaObj={metaObj} key={index} />
        ))}
      </Table>

      <hr className={styles.separador} />
      <h3 className={styles.subTitulo}>Organização da Sociedade Civil:</h3>
      <Table
        listTitle={[
          "Etapa/Fase",
          "Ano",
          "Jan",
          "Fev",
          "Mar",
          "Abr",
          "Mai",
          "Jun",
          "Jul",
          "Ago",
          "Set",
          "Out",
          "Nov",
          "Dez",
          "Total",
          "",
        ]}
        styleList={[1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]}
      >
        {listaAplicacoesOSC.map((metaObj, index) => (
          <RowCalendario metaObj={metaObj} key={index} />
        ))}
      </Table>

      <div className="flex justify-between">
        <button
          className={styles.passarTelaBtn}
          onClick={() => {
            voltarPagina();
          }}
        >
          ❮❮ Anterior
        </button>
        <button
          className={styles.passarTelaBtn}
          onClick={() => {
            passarPagina();
          }}
        >
          Proximo ❯❯
        </button>
      </div>
    </div>
  );
}

export default ReceitasDespesas;
